
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CsPluDialog extends Serenity.EntityDialog<CsPluRow, any> {
        protected getFormKey() { return CsPluForm.formKey; }
        protected getIdProperty() { return CsPluRow.idProperty; }
        protected getLocalTextPrefix() { return CsPluRow.localTextPrefix; }
        protected getNameProperty() { return CsPluRow.nameProperty; }
        protected getService() { return CsPluService.baseUrl; }
        protected getDeletePermission() { return CsPluRow.deletePermission; }
        protected getInsertPermission() { return CsPluRow.insertPermission; }
        protected getUpdatePermission() { return CsPluRow.updatePermission; }

        protected form = new CsPluForm(this.idPrefix);
        public PluDesc: string;
        constructor() {
            super();
    
            this.form.SkuCode.changeSelect2(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                var sku :string = this.form.SkuCode.value
                if (skucode != null) {

                    
                    this.form.PluCode.value = CsSkuRow.getLookup().itemById[sku].SkuCode;
                    this.form.PluDesc.value = CsSkuRow.getLookup().itemById[sku].SkuDesc;
                    this.form.StyleId.value = CsSkuRow.getLookup().itemById[sku].StyleId;
                    this.form.ColorId.value = CsSkuRow.getLookup().itemById[sku].ColorId;
                    this.form.MatTypeId.value = CsSkuRow.getLookup().itemById[sku].MatTypeId;
                    this.form.SizeId.value = CsSkuRow.getLookup().itemById[sku].SizeId;
                    this.form.TasteId.value = CsSkuRow.getLookup().itemById[sku].TasteId;
                    this.form.SellUnit.value = CsSkuRow.getLookup().itemById[sku].StkUnit;
                    
                }
            });
            this.form.PluDesc.changeSelect2(e => {
                var pludesc = Q.toId(this.form.PluDesc.value);
                if (pludesc != null) {

                    
                    this.PluDesc = this.form.PluDesc.value
                    this.form.PluShortDesc.value = this.PluDesc ;

                }
            });
        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            return [];
        }
    }
}